import React, { useRef, useEffect, useState } from 'react';
import classNames from 'clsx';
import { useMeasure } from '@wix/fast-gallery-navigator';
import s from './Gallery.scss';
import Item from '../item/Item';
import { makeEventsListener } from '@wix/fast-gallery-library';
const Gallery = _ref => {
  let {
    galleryId,
    dataList,
    selectors,
    customRenderers,
    eventsListener = () => {}
  } = _ref;
  const [navigator, setNavigator] = useState(null);
  const scrollerRef = useRef(null);
  const containerRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const galleryEventsListener = makeEventsListener().CURRENT_ITEM_CHANGED(eventData => {
    setCurrentIndex(eventData.index);
  }).done(eventsListener);
  useEffect(() => {
    const loadNavigator = async () => {
      const {
        Navigator
      } = await import( /* webpackChunkName: "Navigator" */
      '@wix/fast-gallery-navigator');
      setNavigator(new Navigator({
        initSettings: {},
        eventsListener: galleryEventsListener
      }));
    };
    loadNavigator();
  }, []);
  useEffect(() => {
    if (navigator === null) {
      return;
    }
    navigator.setScrollerRef(scrollerRef);
    navigator.setContainerRef(containerRef);
    navigator.updateTotalItemsCount(5);
    return () => {
      if (navigator === null) {
        return;
      }
      navigator.removeScrollerRef(scrollerRef);
      navigator.removeContainerRef(containerRef);
    };
  }, [navigator, scrollerRef]);
  const handleScrollerMeasure = newMeasurements => {
    navigator == null || navigator.updateScrollerMeasurements(newMeasurements);
  };
  const handleContainerMeasure = newMeasurements => {
    navigator == null || navigator.updateContainerMeasurements(newMeasurements);
  };
  const handleItemMeasure = (index, newMeasurements, itemRef) => {
    navigator == null || navigator.updateItemMeasurements(newMeasurements, index, itemRef);
  };
  useMeasure({
    callback: measurements => handleScrollerMeasure(measurements),
    ref: scrollerRef
  });
  useMeasure({
    callback: measurements => handleContainerMeasure(measurements),
    ref: containerRef
  });
  return /*#__PURE__*/React.createElement("div", {
    id: galleryId || 'root',
    className: classNames(s.root, 'root', selectors == null ? void 0 : selectors.root)
  }, /*#__PURE__*/React.createElement("div", {
    ref: scrollerRef,
    id: "scroller",
    className: classNames(s.scroller, 'scroller')
  }, /*#__PURE__*/React.createElement("div", {
    ref: containerRef,
    className: classNames(s.container, 'container', selectors == null ? void 0 : selectors.container),
    role: "list"
  }, dataList.map((data, index) => /*#__PURE__*/React.createElement(Item, {
    key: crypto.randomUUID(),
    index: index,
    data: data,
    selectors: selectors,
    customRenderers: customRenderers,
    eventsListener: galleryEventsListener,
    onMeasure: handleItemMeasure,
    activeIndex: currentIndex
  })))));
};
export default Gallery;
//# sourceMappingURL=Gallery.js.map